import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
// eslint-disable-next-line import/no-extraneous-dependencies
import { SlhCoreGoogleMap } from "@slhuicore/google-map";

/**
 * Renders a static or interactive Google map view, using Maps Static or Embed API
 */
@customElement("slh-google-map")
export default class SlhGoogleMap extends SlhCoreGoogleMap(LitElement) {}
